import React from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

import Helper from "../../helper";
import Appconfig from "../../config/config";
import "./CasinoImageGrid.css";

export const casinoGames = [
  {
    id: 1,
    name: "Fantasy 11",
    desktopImage: "may-fantasy-02_1776278869563.3457.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["fantasy11"],
    desktopTypes: ["others"],
  },
  {
    id: 2,
    name: "Amar Akbar Anthony",
    desktopImage: "amar_akbar_anthony.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 3,
    name: "3 Card Judgement",
    desktopImage: "3cj.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 4,
    name: "Queen Race",
    desktopImage: "queen.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 5,
    name: "Race 20",
    desktopImage: "race_20.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 6,
    name: "Casino War",
    desktopImage: "casino_war.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 7,
    name: "Worli Matka",
    desktopImage: "worli_matka.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 8,
    name: "Trio",
    desktopImage: "trio.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 9,
    name: "Bollywood Casino",
    desktopImage: "bollywood_casino.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 10,
    name: "10 Ka Dum",
    desktopImage: "10kadum.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 11,
    name: "1 Card 20 20",
    desktopImage: "1_card_20_20.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 12,
    name: "One Card One Day",
    desktopImage: "1c1d.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 13,
    name: "Race 17",
    desktopImage: "race_17.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 14,
    name: "Note Number",
    desktopImage: "notenumber.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 15,
    name: "Center Card",
    desktopImage: "cc.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 16,
    name: "High Card",
    desktopImage: "hc.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 17,
    name: "Football Studio Dice",
    desktopImage: "fs.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 18,
    name: "Mac88 Lobby",
    desktopImage: "lobby_mac88.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 19,
    name: "Moles",
    desktopImage: "moles.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 20,
    name: "Snakes & Ladders",
    desktopImage: "snl.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 21,
    name: "Gem Drop",
    desktopImage: "gemdrop.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 22,
    name: "Prism",
    desktopImage: "prism.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 23,
    name: "Marble Run",
    desktopImage: "marblerun.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 24,
    name: "Olympus Realms",
    desktopImage: "olympusrealms.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 25,
    name: "Loot Boxes",
    desktopImage: "lootboxes.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 26,
    name: "Baloon Rush",
    desktopImage: "balloonrush.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 27,
    name: "Dragon Rites",
    desktopImage: "dragonrites.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 28,
    name: "Race Track",
    desktopImage: "racetrack.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 29,
    name: "UNC Ball",
    desktopImage: "uncball.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 30,
    name: "Hand Cricket",
    desktopImage: "handcricket.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 31,
    name: "Tower Rush",
    desktopImage: "glxsy_towerrush.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 32,
    name: "Volt Run",
    desktopImage: "voltrun.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 33,
    name: "Wicket Blast",
    desktopImage: "wicketblast.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 34,
    name: "Rang Racer",
    desktopImage: "rangracer.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 35,
    name: "Solitaire",
    desktopImage: "solitaire.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 36,
    name: "Bomb Defuse",
    desktopImage: "bombdefuse.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 37,
    name: "Golden Kick",
    desktopImage: "goldenkick.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 38,
    name: "Coin Flip",
    desktopImage: "flip.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 39,
    name: "Furtune Wheel",
    desktopImage: "fortunewheel.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 40,
    name: "Jhandi Munda",
    desktopImage: "jhandimunda.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 41,
    name: "Pump",
    desktopImage: "pump.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 42,
    name: "Deal Or No Deal",
    desktopImage: "dnd.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 43,
    name: "The Voice",
    desktopImage: "voice.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 44,
    name: "Barrel Blast",
    desktopImage: "barrelblast.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 45,
    name: "Card Stopper",
    desktopImage: "cardstopper.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 46,
    name: "Center Card Virtual",
    desktopImage: "vr_cc.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 47,
    name: "Royal Pictures",
    desktopImage: "royalpictures.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 48,
    name: "Cricket Battle",
    desktopImage: "cricketbattle.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 49,
    name: "Instant Worli Virtual",
    desktopImage: "virtual_instant_worli.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 50,
    name: "Trio Virtual",
    desktopImage: "vr_trio.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 51,
    name: "Bollywood Casino Virtual",
    desktopImage: "vr_bc.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 52,
    name: "Amar Akbar Anthony Virtual",
    desktopImage: "vr_aaa.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 53,
    name: "Casino Meter Virtual",
    desktopImage: "vr_casinometer.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 54,
    name: "Queen Race Virtual",
    desktopImage: "vr_queen.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 55,
    name: "Race 20 Virtual",
    desktopImage: "vr_race_20.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 56,
    name: "Worli Matka Virtual",
    desktopImage: "vr_worlimatka.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 57,
    name: "High Card Virtual",
    desktopImage: "vr_hc.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 58,
    name: "Ball By Ball Virtual",
    desktopImage: "bbb.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: "59-hilo",
    name: "Hi Lo",
    desktopImage: "tbg_hilo.jpg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 59,
    name: "Crystal Poker",
    desktopImage: "tbg_crystalpoker.jpg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 60,
    name: "Rings Of Olympus",
    desktopImage: "ringsofolympus.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 61,
    name: "Tapinata Hallowen",
    desktopImage: "tbg_tapinata.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 62,
    name: "Speed Bingo 90",
    desktopImage:
      "ez_speed_bingo_90_thumbnail_1280x720_2025_06_1765803908313.0916.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 64,
    name: "EZ Marble Race",
    desktopImage:
      "ez_marble_race_las_vegas_thumbnail_1280x720_2025_09_01_1765801041199.3164.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 65,
    name: "EZ Marble Race Monaco",
    desktopImage:
      "ez_marble_race_thumbnail_1280x720_2025_03_01_1765801088017.8757.jpg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 66,
    name: "Ultimate Flip",
    desktopImage:
      "ultimate_flip_thumbnail_1280x720_2025_03_01_1765802916837.1528.jpg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 67,
    name: "Xoc Dia",
    desktopImage: "xoc_dia_thumbnail_1280x720_2025_02_01_1765803321608.242.jpg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 68,
    name: "Paper Toss",
    desktopImage: "tri_papertoss.jpg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 69,
    name: "Aalam Doodh Soda",
    desktopImage: "tri_aalamdoodhsoda.jpg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 70,
    name: "Chicker Chase",
    desktopImage: "tri_chickenchase.jpg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 71,
    name: "Street Racer",
    desktopImage: "tri_streetracer.jpg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 72,
    name: "Candy Pop",
    desktopImage: "tri_candypop.jpg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 73,
    name: "Golden Ticket",
    desktopImage: "tri_goldenticket.jpg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 74,
    name: "Thunders Of Olyumpus",
    desktopImage: "tri_thundersofolympus.jpg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 75,
    name: "Roll X",
    desktopImage: "sms_roll_x.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 76,
    name: "Book Of Futuria",
    desktopImage: "sms_book_of_futuria.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 77,
    name: "Patricks Magic Field",
    desktopImage: "evp_stpatriksthemedgame.jpg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 78,
    name: "Balloon",
    desktopImage: "balloon.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 79,
    name: "Trader",
    desktopImage: "trader.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 80,
    name: "Avinho Qiu",
    desktopImage: "avinho.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 81,
    name: "Marble Plinko",
    desktopImage: "marble_plinko_classic.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 82,
    name: "Rolling Dunes",
    desktopImage: "rolling_dunes_classic.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 83,
    name: "Snake",
    desktopImage: "snake_classic.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 84,
    name: "Stairpong",
    desktopImage: "marbles_stairpong.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 85,
    name: "Perfect Catch",
    desktopImage: "mig_perfect_catch.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 86,
    name: "Mig Baccarat",
    desktopImage: "mig_million_baccarat.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 87,
    name: "Blackjack Peek",
    desktopImage: "mig_million_blackjack_peek.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 88,
    name: "Thorfinn's Journey",
    desktopImage: "mig_thorfinns_journey.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 89,
    name: "Million Plinko",
    desktopImage: "mig_million_plinko.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 90,
    name: "Captain's Curse",
    desktopImage: "mig_captains_curse.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 91,
    name: "Vault Rush",
    desktopImage: "mig_vault_rush.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 92,
    name: "Island Ices",
    desktopImage: "mig_island_ices.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 93,
    name: "Farm Frenzy",
    desktopImage: "mig_farm_frenzy.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: "94-fortune-fairies",
    name: "Fortune Fairies",
    desktopImage: "mig_fortune_fairies.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 94,
    name: "Ghost Harbour",
    desktopImage: "mig_ghost_harbour.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 95,
    name: "Amar Akbar Anthony Macexcite",
    desktopImage: "aaa.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 96,
    name: "3 Card Judgement Macexcite",
    desktopImage: "3cj.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 97,
    name: "Queen Macexcite",
    desktopImage: "queen.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 98,
    name: "Race 20 Macexcite",
    desktopImage: "r20.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 99,
    name: "Casino War Macexcite",
    desktopImage: "cw.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 100,
    name: "Worli Matka Macexcite",
    desktopImage: "wm.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 101,
    name: "Trio Macexcite",
    desktopImage: "trio.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 102,
    name: "Bollywood Casino Macexcite",
    desktopImage: "bc.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 103,
    name: "Dus Ka Dum Macexcite",
    desktopImage: "dkd.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 104,
    name: "1 Card 20 20 Macexcite",
    desktopImage: "1c.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 105,
    name: "Race To 17 Macexcite",
    desktopImage: "race17.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 106,
    name: "Note Number Macexcite",
    desktopImage: "nn.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 107,
    name: "One Card One Day Macexcite",
    desktopImage: "1c1d.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 108,
    name: "Center Card Macexcite",
    desktopImage: "cc.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 109,
    name: "Football Studio Dice Macexcite",
    desktopImage: "fsd.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 110,
    name: "High Card Macexcite",
    desktopImage: "hc.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 111,
    name: "Work Hunt",
    desktopImage: "wordhunt.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 112,
    name: "Flower Frenzy",
    desktopImage: "flowerfrenzy.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 113,
    name: "Grand Slam",
    desktopImage: "grandslam.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 114,
    name: "Bingo Border",
    desktopImage: "bingoborder.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 115,
    name: "Funky Fridays",
    desktopImage: "funkyfridays.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 116,
    name: "Majestic Bingo",
    desktopImage: "majesticbingo.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 117,
    name: "Magic Square Bingo",
    desktopImage: "magicsquarebingo.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: "118-fortune-40",
    name: "Fortune 40",
    desktopImage: "fortune40.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 118,
    name: "Sporty 60 Bingo",
    desktopImage: "sporty60.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 119,
    name: "Crazy 80",
    desktopImage: "crazy80.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 120,
    name: "Bingo Party",
    desktopImage: "bingoparty.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 121,
    name: "Cold Jewels",
    desktopImage: "coldjewels.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 122,
    name: "Flip & Win",
    desktopImage: "flipandwin.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 123,
    name: "Puzzle Museum",
    desktopImage: "puzzlemuseum.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 124,
    name: "Stardust Bingo",
    desktopImage: "stardust.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 125,
    name: "Mighty 90",
    desktopImage: "mighty90.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 126,
    name: "Shiny Diamonds Bingo",
    desktopImage: "shinydiamonds.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 127,
    name: "Bling Bingo",
    desktopImage: "bling.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 128,
    name: "Flash Bingo",
    desktopImage: "flash.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 129,
    name: "Matka",
    desktopImage: "matka.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["others"],
  },
  {
    id: 130,
    name: "Dragon Tiger",
    desktopImage: "dt_mac88.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 131,
    name: "Dragon Tiger Lion",
    desktopImage: "dtl_20_20.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 132,
    name: "Dragon Tiger 1 Day",
    desktopImage: "dt_1day.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 133,
    name: "Dragon Tiger 2",
    desktopImage: "dt2.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 134,
    name: "20 20 Dragon Tiger Virtual",
    desktopImage: "vr_2020_dtl.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 135,
    name: "Dragon Tiger Virtual",
    desktopImage: "vr_dragontiger.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 136,
    name: "Dragon Tiger Sexy",
    desktopImage: "sdt.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 137,
    name: "Dragon Tiger Sexy 2",
    desktopImage: "sdt2.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 138,
    name: "Dragon Tiger Sexy 3",
    desktopImage: "sdt3.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 139,
    name: "Dragon Tiger Ezugi",
    desktopImage:
      "dragon_tiger_thumbnail_1280x720_2023_11_1765799561625.8384.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 140,
    name: "Dragon Tiger Da Sorte",
    desktopImage:
      "dragon_tiger_da_sorte_thumbnail_1280x720_2025_09_01_1765799761964.8784.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 141,
    name: "Dragon Tiger Altira Macau",
    desktopImage: "altiramaca_1780563445759.1265.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 142,
    name: "Dragon Tiger Casino Waldo",
    desktopImage: "casinowald_1780563608565.0757.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 143,
    name: "Dragon Tiger Dragon Rise",
    desktopImage: "dragonriseinternationa_1780564364362.1611.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 144,
    name: "Dragon Tiger Dukes",
    desktopImage: "duke_1780563648473.8035.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 145,
    name: "Dragon Tiger Remarld Bay",
    desktopImage: "rmeraldba_1780565987576.6443.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 146,
    name: "Dragon Tiger Fortune Macau",
    desktopImage: "fortunemaca_1780563724818.9868.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 147,
    name: "Dragon Tiger Fortune Macau",
    desktopImage: "fortunemaca_1780563724818.9868.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 148,
    name: "Dragon Tiger Four Seasons",
    desktopImage: "fourseason_1780563744257.512.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 149,
    name: "Dragon Tiger Golden Coast",
    desktopImage: "goldencoas_1780563854031.7983.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 150,
    name: "Dragon Tiger Golden Lily",
    desktopImage: "goldenlil_1780563879073.1375.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 151,
    name: "Dragon Tiger Harbor",
    desktopImage: "harborviewresor_1780034526727.102.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 152,
    name: "Dragon Tiger Are Casino",
    desktopImage: "larccasin_1780564520088.7642.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 153,
    name: "Dragon Tiger Pearl Bay",
    desktopImage: "pearlba_1780564848729.5537.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 154,
    name: "Dragon Tiger Ponte 16",
    desktopImage: "ponte2_1780564926319.486.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 155,
    name: "Dragon Tiger Royal Palace",
    desktopImage: "royalpalac_1780567733529.5789.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 156,
    name: "Dragon Tiger Ruby Red",
    desktopImage: "rubyre_1780567753732.1575.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 157,
    name: "Dragon Tiger Saigon Nights",
    desktopImage: "saigonnight_1780566039787.1265.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 158,
    name: "Dragon Tiger Sea Breeze",
    desktopImage: "seabreezeinternationa_1780566109602.2827.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 159,
    name: "Dragon Tiger Sheraton",
    desktopImage: "sherato_1780565077695.38.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 160,
    name: "Dragon Tiger Treasure Coast",
    desktopImage: "treasurecoas_1780034993033.998.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 161,
    name: "Dragon Tiger CreedRoomz",
    desktopImage: "dragon_tiger_40003097_440x310_1788252381259.6123.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 162,
    name: "Dragon Tiger Evolution",
    desktopImage:
      "dragon_dragon_branded_thumbnail_1280x720_2026_0_1782294288227.8477.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 163,
    name: "Dragon Tiger Evolution Sexxy",
    desktopImage: "dragontiger_1779182950971.184.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 164,
    name: "Dragon Tiger Evolution MacExcite",
    desktopImage: "dt.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 165,
    name: "Dragon Tiger Lion Mac Excite",
    desktopImage: "dtl.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 166,
    name: "Dragon Tiger One Day",
    desktopImage: "dt1d.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 167,
    name: "Dragon Tiger 2 Mac Excite",
    desktopImage: "dt2.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 168,
    name: "Dragon Tiger Live",
    desktopImage:
      "dragon_tiger_banner_1080x1080_2021_02_01_1758880785307.8684.jpg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 169,
    name: "Dragon Tiger Live 2",
    desktopImage:
      "dragon_tiger_banner_1080x1080_2021_02_03_1764322994650.1096.jpg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 170,
    name: "Dragon Tiger Emperor",
    desktopImage:
      "emperor_dragon_tiger_banner_1980x800_2022_09_01_1758881072524.9385.jpg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 171,
    name: "Dragon Tiger First Person",
    desktopImage: "first-person-dragon-tiger-296_1761546174572.4397.jpg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 172,
    name: "Dragon Tiger Livee",
    desktopImage:
      "dragon_tiger_banner_1080x1080_2021_02_03_1764322436493.8086.jpg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["dragon-tiger"],
  },
  {
    id: 173,
    name: "Lightining Dragon Tiger",
    desktopImage: "1-lightning-dragon-tiger.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 174,
    name: "Lightining Andar Bahar",
    desktopImage: "2-lightning-andar-bahar.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 175,
    name: "Lightining Amar Akbar Anthony",
    desktopImage: "3-lightning-amar-akbar-anthony.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 176,
    name: "Lightining Bollywood Casino",
    desktopImage: "4-lightning-bollywood-casino.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 177,
    name: "Lightining Instant Super Over",
    desktopImage: "5-lightning-instant-super-over.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 178,
    name: "Lightining 20-20 Teenpatti",
    desktopImage: "23-lightning-20-20-teenpatti.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 179,
    name: "Lightining Dragon Tiger 2",
    desktopImage: "19-lightning-dragon-tiger-2.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 180,
    name: "Lightining Baccarat",
    desktopImage: "8-lightning-baccarat.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 181,
    name: "Lightining Lucky 5",
    desktopImage: "22-lightning-lucky-5.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 182,
    name: "Lightining Lucky 7",
    desktopImage: "10-lightning-lucky-7.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 183,
    name: "Lightining 20-20 Teenpatti 2",
    desktopImage: "24-lightning-20-20-teenpatti-2.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 184,
    name: "Lightining Roulette",
    desktopImage: "13-lightning-roulette.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 185,
    name: "Lightining Baccarat Sexy",
    desktopImage: "14-sexy-lightning-baccarat.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 186,
    name: "Lightining Dragon Tiger Sexy",
    desktopImage: "15-sexy-lightning-dragon-tiger.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 187,
    name: "Lightining Dragon Tiger Sexy",
    desktopImage: "15-sexy-lightning-dragon-tiger.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 188,
    name: "Lightining Dragon Tigerr",
    desktopImage: "16-lightning-dragon-tiger.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 189,
    name: "Lightining Dragon Tigerr",
    desktopImage: "16-lightning-dragon-tiger.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 190,
    name: "Lightining Baccaratt",
    desktopImage: "17-lightning-baccarat.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 191,
    name: "Lightining Sicbo",
    desktopImage: "18-lightning-sicbo.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 192,
    name: "Lightining Sicbo",
    desktopImage: "18-lightning-sicbo.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 193,
    name: "Lightining Teenpatti 20-20",
    desktopImage: "23-lightning-20-20-teenpatti.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 194,
    name: "Lightining Teenpatti 20-20 2",
    desktopImage: "24-lightning-20-20-teenpatti-2.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 195,
    name: "Lightining Lucky 7 2",
    desktopImage: "21-lightning-lucky-7.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 196,
    name: "Lightining Lucky 5",
    desktopImage: "12-lightning-lucky-5.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["lightning"],
  },
  {
    id: 197,
    name: "Teenpatti 20 20",
    desktopImage: "20_20_teenpatti.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 198,
    name: "Teenpatti One Day",
    desktopImage: "tp1d.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 199,
    name: "Test Teenpatti",
    desktopImage: "teenpatti_test.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 200,
    name: "2 Card Teenpatti 1 Day",
    desktopImage: "2_cards_teenpatti.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 201,
    name: "Muflis Teenpatti 1 Day",
    desktopImage: "muflis_teenpatti.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 202,
    name: "2 Card Teenpatti",
    desktopImage: "2_card_tp.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 203,
    name: "Open Teenpatti",
    desktopImage: "open_teen_patti.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 204,
    name: "Muflis Teenpatti",
    desktopImage: "mtp.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 205,
    name: "Instant Teenpatti",
    desktopImage: "itp.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 206,
    name: "Teenpatti 20-20 2",
    desktopImage: "2020tp2.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 207,
    name: "AK 47 Teenpatti",
    desktopImage: "ak47tp.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 208,
    name: "Teenpatti Joker 20 20",
    desktopImage: "TPJ2020.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 209,
    name: "Teenpatti Joker One Day",
    desktopImage: "JPT1D.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: "209-teenpatti-poison",
    name: "Poison Teenpatti 20 20",
    desktopImage: "PTP.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 210,
    name: "Unique Teenpatti",
    desktopImage: "UTP.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 211,
    name: "Joker Teenpatti 1 Day",
    desktopImage: "VJTP1D.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 212,
    name: "Muflis Teenpatti Virtual",
    desktopImage: "vr_mtp.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 213,
    name: "20 20 Teenpatti Virtual",
    desktopImage: "vr_tp2020.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 214,
    name: "2 Card Teenpatti Virtual",
    desktopImage: "vr_2ctp.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 215,
    name: "AK 47 Teenpatti Virtual",
    desktopImage: "ak47_vr.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 216,
    name: "Teenpatti One Day Sexy",
    desktopImage: "STP1D.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 217,
    name: "Teenpatti 20-20 Sexy",
    desktopImage: "STPTT.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 218,
    name: "2 Card Teenpatti Sexy",
    desktopImage: "s2ctp.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 219,
    name: "Bet-On Teenpatti",
    desktopImage: "bet_on_teen_patti_thumbnail_1280x720_2023_09_1765798380715.4724.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 220,
    name: "One-Day Teenpatti",
    desktopImage: "one_day_teen_patti_thumbnail_1280x720_2025_11_1765801362254.0789.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 221,
    name: "Teenpatti Three Card",
    desktopImage: "teen_patti_three_card_thumbnail_1280x720_2025_11_01_1765802752287.7563.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 222,
    name: "Teenpatti One Day MacExcite",
    desktopImage: "tp1d.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 223,
    name: "Test Teenpatti MacExcite",
    desktopImage: "ttp.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 224,
    name: "2 Card Teenpatti MacExcite",
    desktopImage: "2ctp.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 225,
    name: "Muflis Teenpatti One Day MacExcite",
    desktopImage: "mtp1d.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 226,
    name: "Teenpatti 20 20 MacExcite",
    desktopImage: "2020tp.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 227,
    name: "Instant 2 Card Teenpatti MacExcite",
    desktopImage: "instant_2ctp.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 228,
    name: "Open Teenpatti MacExcite",
    desktopImage: "otp.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 229,
    name: "20-20 Teenpatti 2 MacExcite",
    desktopImage: "2020tp2MX.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 230,
    name: "Muflis Teenpatti MacExcite",
    desktopImage: "mtpMX.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 231,
    name: "AK 47 Teenpatti MacExcite",
    desktopImage: "ak47tpMX.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 232,
    name: "Instant Teenpatti MacExcite",
    desktopImage: "itpMX.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 233,
    name: "Teenpatti Joker 20-20 MacExcite",
    desktopImage: "TPJ2020MX.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 234,
    name: "Joker Teenpatti One Day MacExcite",
    desktopImage: "JTP1DMX.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 235,
    name: "Unique Teenpatti MacExcite",
    desktopImage: "UTPMX.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 236,
    name: "Poison Teenpatti MacExcite",
    desktopImage: "PTPMX.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["teenpatti"],
  },
  {
    id: 237,
    name: "Baccarat",
    desktopImage: "baccarat_mac88.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 238,
    name: "29 Baccarat",
    desktopImage: "29b.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 239,
    name: "29 Baccarat Virtual",
    desktopImage: "vr_29b.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 240,
    name: "Sexy No-Commission Baccarat",
    desktopImage: "sncb.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 241,
    name: "Sexy Baccarat",
    desktopImage: "SB.webp",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 242,
    name: "Baccarat A",
    desktopImage: "baccarat_a_thumbnail_1280x720_2023_09_01_1765803376283.6045.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 243,
    name: "Baccarat B",
    desktopImage: "baccarat_b_thumbnail_1280x720_2023_11_2_1765803433922.869.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 244,
    name: "Casino Marina Baccarat A",
    desktopImage: "casino_marina_baccarat_a_thumbnail_1280x720_2024_04_1765798686908.1465.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 245,
    name: "Casino Marina Baccarat AA",
    desktopImage: "casino_marina_baccarat_a_thumbnail_1280x720_2024_04_1765798751451.5645.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 246,
    name: "Casino Marina Baccarat C",
    desktopImage: "casino_marina_baccarat_c_thumbnail_1280x720_2024_04_1765798802926.6284.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 247,
    name: "Casino Marina Baccarat D",
    desktopImage: "casino_marina_baccarat_d_thumbnail_1280x720_2024_04_1765798859068.566.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 248,
    name: "EZ Marina Baccarat",
    desktopImage: "ez_baccarat_thumbnail_1280x720_2025_11_02_1772147052731.9543.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 249,
    name: "Amber Baccarat",
    desktopImage: "baccaratambe_1780563505277.3323.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 250,
    name: "Amsterdam Baccarat",
    desktopImage: "amsterda_1780566441490.1448.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 251,
    name: "Agertina Baccarat",
    desktopImage: "argentin_1780563471861.0288.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 252,
    name: "Barcelona Baccarat",
    desktopImage: "barcelon_1780565269832.2683.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 253,
    name: "Belo Baccarat",
    desktopImage: "bel_1780566462881.763.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 254,
    name: "Berlin Baccarat",
    desktopImage: "berli_1780565391748.7988.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 255,
    name: "Bein Hoa Baccarat",
    desktopImage: "bienho_1780566486657.2268.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 256,
    name: "Blaze Baccarat",
    desktopImage: "blaz_1780563575666.4397.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 257,
    name: "Brasilia Baccarat",
    desktopImage: "brasli_1780566515291.0127.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 258,
    name: "Brazil Baccarat",
    desktopImage: "brazi_1780563594109.0432.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 259,
    name: "Broadway Macau Baccarat",
    desktopImage: "broadwaymaca_1780566541277.4104.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 260,
    name: "Brussels Baccarat",
    desktopImage: "brussel_1780566565206.614.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 261,
    name: "Bucharest Baccarat",
    desktopImage: "buchares_1780564151884.2834.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 262,
    name: "Budapest Baccarat",
    desktopImage: "budapes_1780565421826.0833.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 263,
    name: "Buon Baccarat",
    desktopImage: "buonmathuo_1780566593585.1714.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 264,
    name: "Busan Baccarat",
    desktopImage: "busa_1780566612499.7031.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 265,
    name: "Campinas Baccarat",
    desktopImage: "campina_1780565447527.5535.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 266,
    name: "Can Tho Baccarat",
    desktopImage: "canth_1780564176826.916.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 267,
    name: "Changwon Baccarat",
    desktopImage: "changwo_1780566633631.3943.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 268,
    name: "Copenhagen Baccarat",
    desktopImage: "copenhage_1780564200313.568.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 269,
    name: "Croatia Baccarat",
    desktopImage: "croati_1780564218531.8008.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 270,
    name: "Crown Macau Baccarat",
    desktopImage: "crownmaca_1780565514742.725.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 271,
    name: "Curitiba Baccarat",
    desktopImage: "curitib_1780566673144.1475.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 272,
    name: "Da Nang Baccarat",
    desktopImage: "danan_1780565565682.274.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 273,
    name: "Daegu Baccarat",
    desktopImage: "daeg_1780564265672.9558.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 274,
    name: "Daejeon Baccarat",
    desktopImage: "daejeo_1780565540431.7085.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 275,
    name: "Dalat Baccarat",
    desktopImage: "dala_1780564283363.2156.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 276,
    name: "Emerald Baccarat",
    desktopImage: "emeral_1780563680118.0823.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 277,
    name: "Fortaleza Baccarat",
    desktopImage: "fortalez_1780566704314.7812.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 278,
    name: "France Baccarat",
    desktopImage: "franc_1780563767828.0762.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 279,
    name: "Galaxy Group Baccarat",
    desktopImage: "galaxygrou_1780566724970.3901.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 280,
    name: "Gangneung Baccarat",
    desktopImage: "gangneun_1780565584267.022.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 281,
    name: "Goyang Baccarat",
    desktopImage: "goyan_1780565604598.233.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 282,
    name: "Grand Lisboa Baccarat",
    desktopImage: "grandlisbo_1780566952692.9573.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 283,
    name: "Gwangju Lisboa Baccarat",
    desktopImage: "gwangj_1780565625608.328.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 284,
    name: "Heart Baccarat",
    desktopImage: "t9o2cwhear_1780566391562.1582.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 285,
    name: "Ho Chi Min City Baccarat",
    desktopImage: "hochiminhcit_1780567235827.6487.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 286,
    name: "Hoi An Baccarat",
    desktopImage: "hoia_1780567257074.4285.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 287,
    name: "Incheon Baccarat",
    desktopImage: "incheo_1780564414473.6057.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 288,
    name: "Isha Roulette",
    desktopImage: "ish_1780567412729.1133.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 289,
    name: "London Baccarat",
    desktopImage: "londo_1780565718309.2107.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 290,
    name: "Manaus Baccarat",
    desktopImage: "manaus_1780565781656.9275.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 291,
    name: "Masan Baccarat",
    desktopImage: "masa_1780567452131.1853.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 292,
    name: "MGM Macau Baccarat",
    desktopImage: "mgmmaca_1780567475578.3848.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 293,
    name: "Milan Baccarat",
    desktopImage: "mila_1780567493918.8357.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 294,
    name: "Moscow Baccarat",
    desktopImage: "mosco_1780567518774.1543.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 295,
    name: "Mui Ne Baccarat",
    desktopImage: "muin_1780567549068.267.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 296,
    name: "My Tho Baccarat",
    desktopImage: "myth_1780567587222.1147.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 297,
    name: "Nha Trang Baccarat",
    desktopImage: "nhatran_1780565825878.107.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 298,
    name: "Osasco Baccarat",
    desktopImage: "osasc_1780565852683.2437.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 299,
    name: "Palace Casino Baccarat",
    desktopImage: "palacecasin_1780564771902.0022.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 300,
    name: "Pandora Baccarat",
    desktopImage: "baccaratpandor_1780563524498.3809.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 301,
    name: "Paris Baccarat",
    desktopImage: "pari_1780565888525.5183.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 302,
    name: "Sau Paola Baccarat",
    desktopImage: "parisianmaca_1780567611077.988.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 303,
    name: "Phu Quoc Baccarat",
    desktopImage: "phuquo_1780564865762.2627.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 304,
    name: "Plaid Baccarat",
    desktopImage: "plai_1780564903424.7876.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 305,
    name: "Porto Alegre Baccarat",
    desktopImage: "portoalegr_1780567632929.7893.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 306,
    name: "Prague Baccarat",
    desktopImage: "pragu_1780564962897.0564.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 307,
    name: "Recife Baccarat",
    desktopImage: "recif_1780567680119.9568.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 308,
    name: "Reindeer Baccarat",
    desktopImage: "reindee_1780564984527.339.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 309,
    name: "Rio De Janerio Baccarat",
    desktopImage: "riodejaneir_1780567700703.6536.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 310,
    name: "Rome Baccarat",
    desktopImage: "rom_1780566014052.108.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 311,
    name: "Sa Pa Baccarat",
    desktopImage: "sap_1780567821883.5857.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 312,
    name: "Salvador Baccarat",
    desktopImage: "salvado_1780566064835.7124.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 313,
    name: "Sandas Macao Baccarat",
    desktopImage: "sandsmaca_1780567797507.9788.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 314,
    name: "Santo Andre Baccarat",
    desktopImage: "santoand_1780566086693.6245.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 315,
    name: "Sao Luis Baccarat",
    desktopImage: "solu_1780566304672.4973.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 316,
    name: "Sao Paulo Baccarat",
    desktopImage: "sopaul_1780566324168.8176.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 317,
    name: "Sejong Baccarat",
    desktopImage: "sejon_1780567859796.6948.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 318,
    name: "Seoul Baccarat",
    desktopImage: "seou_1780566131703.8247.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 319,
    name: "SJM Holdings Baccarat",
    desktopImage: "sjmholding_1780566157015.856.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 320,
    name: "Snow Baccarat",
    desktopImage: "sno_1780566234055.664.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 321,
    name: "Spain Baccarat",
    desktopImage: "spai_1780565128322.0664.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 322,
    name: "Suncity Group Baccarat",
    desktopImage: "suncitygrou_1780566370835.4053.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 323,
    name: "Suwon Baccarat",
    desktopImage: "suwo_1780567895288.353.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 324,
    name: "Thanh Hoa Baccarat",
    desktopImage: "thanhho_1780567914453.0403.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 325,
    name: "The Venetian Baccarat",
    desktopImage: "thevenetian_1780567930681.216.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 326,
    name: "Vienna Baccarat",
    desktopImage: "vienn_1780566414091.4045.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 327,
    name: "Vitoria Baccarat",
    desktopImage: "vitri_1780567948698.3228.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 328,
    name: "Wynn Baccarat",
    desktopImage: "wyn_1780567963485.952.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 329,
    name: "Yeosu Baccarat",
    desktopImage: "yeos_1780565246208.9995.jpeg",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 330,
    name: "Inter 1 Baccarat",
    desktopImage: "baccarat_inter_1_1790573101093.09.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 331,
    name: "Inter 2 Baccarat",
    desktopImage: "baccarat_inter_2_1790573132262.3562.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 332,
    name: "Speed Inter 1 Baccarat",
    desktopImage: "speed_baccarat_inter_1_1790573160898.485.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 333,
    name: "Speed Inter 2 Baccarat",
    desktopImage: "speed_baccarat_inter_2_1790573187720.5295.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 334,
    name: "Speed Inter 3 Baccarat",
    desktopImage: "speed_baccarat_inter_3_1790573212415.6013.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 335,
    name: "Speed Inter 4 Baccarat",
    desktopImage: "speed_baccarat_inter_4_1790573246452.7244.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
  {
    id: 336,
    name: "Speed Inter 5 Baccarat",
    desktopImage: "speed_baccarat_inter_5_1790573269144.1582.png",
    providerCode: "SPB",
    gameCode: "goal",

    desktopProviders: ["all"],
    desktopTypes: ["baccarat"],
  },
];

const CasinoImageGrid = () => {
  const navigate = useNavigate();
  const userInfo = Helper();

  const openGame = (game) =>
    CreateAndLaunchWCOCasino(game.providerCode, game.gameCode, game.type);

  const CreateAndLaunchWCOCasino = async (
    providerCode,
    gameCode,
    type = null,
  ) => {
    if (!userInfo?._id) {
      toast.error("Please login to play this game.", {
        autoClose: 2000,
      });

      navigate("/login");
      return false;
    }

    if (!providerCode || !gameCode) {
      console.error("Casino configuration is missing:", {
        providerCode,
        gameCode,
        type,
      });

      toast.error("Game configuration is missing.", {
        autoClose: 2000,
      });

      return false;
    }

    const userData = {
      user_id: userInfo._id,
      user_name: userInfo.user_name,
      redirect_url: "https://daddyexch.live/",
      provider_code: providerCode,
      game_code: gameCode,
      type: type ?? null,
    };

    try {
      console.log("Casino launch payload:", userData);
      console.log("Casino launch endpoint:", `${Appconfig.casinoUrl}wco/login`);

      const response = await axios({
        method: "post",
        url: `${Appconfig.casinoUrl}wco/login`,
        headers: {
          "Content-Type": "application/json",
        },
        data: userData,
      });

      const status = response?.data?.status?.code;
      const launchURL = response?.data?.launchURL;

      if (status === "SUCCESS" && launchURL) {
        window.location.assign(launchURL);
        return true;
      }

      if (status === "VALIDATION_ERROR" || status === "UNKNOWN_ERROR") {
        toast.error("Game Not Found.", {
          autoClose: 2000,
        });

        return false;
      }

      if (status === "AUTHENTICATION_FAILED") {
        toast.error(
          response?.data?.status?.message || "Casino authentication failed.",
          {
            autoClose: 2000,
          },
        );

        return false;
      }

      toast.error(
        response?.data?.status?.message || "Unable to launch this game.",
        {
          autoClose: 2000,
        },
      );

      return false;
    } catch (error) {
      console.error("Casino launch error:", error);

      toast.error(
        error?.response?.data?.status?.message ||
          "Unable to launch casino game.",
        {
          autoClose: 2000,
        },
      );

      return false;
    }
  };

  return (
    <section className="casino-image-section" aria-label="Casino games">
      <div className="casino-image-grid">
        {casinoGames.map((game) => (
          <button
            key={game.id}
            type="button"
            className="casino-image-card"
            onClick={() => openGame(game)}
            title={game.name}
          >
            <span className="casino-card-image">
              <img
                src={
                  game.desktopImage
                    ? `${process.env.PUBLIC_URL}/Images/desktopcasino/${game.desktopImage}`
                    : `${process.env.PUBLIC_URL}/Images/casino-games/${game.image}`
                }
                alt={game.name}
                loading="lazy"
                draggable="false"
                onError={(event) => {
                  event.currentTarget.onerror = null;
                  event.currentTarget.src = game.desktopImage
                    ? `${process.env.PUBLIC_URL}/Images/desktopcasino/default.webp`
                    : `${process.env.PUBLIC_URL}/Images/casino-games/default.webp`;
                }}
              />
            </span>

            <span className="casino-card-title">{game.name}</span>
          </button>
        ))}
      </div>
    </section>
  );
};

export default CasinoImageGrid;
